import { Notify } from 'quasar'
import type { BackendError, BackendErrorDetail } from 'src/types/errors'

export class ApiError extends Error {
  status: number | null
  type: string
  errors: BackendErrorDetail

  constructor (error: BackendError, status: number | null = null) {
    super()
    this.status = status || error.status || null
    this.type = error.type || ''
    this.errors = error.errors || error.error ? [{ attr: null, code: null, detail: error.error as string }] : []

    Object.setPrototypeOf(this, ApiError.prototype)

    if (this.errors.length) {
      for (const e of this.errors) {
        Notify.create({
          color: 'negative',
          position: 'bottom',
          message: `${e.code || e.attr || this.status || ''} - ${e.detail}`,
        })
      }
    }
  }
}
